import React, { useState, useEffect, useCallback, useContext } from 'react';
import SidebarCategory from './SidebarCategory';
import useDynamicPath from '../hooks/useDynamicPath';
import constants from '../constants.json' assert { type: 'json' };
import AppContext from './context/AppContext';

const DEFAULT_MAXIMUM_NAVIGATION_MENU_DEPTH = 6;

const PageSidebarCategoryList = () => {
    const [loadingCollection, setLoadingCollection] = useState(true);
    const [error, setError] = useState(null);
    const [collectionNavigationMenus, setCollectionNavigationMenus] = useState([]);
    const collectionPath = useDynamicPath({ pathName: constants.DYNAMIC_PATHS.COLLECTION_PATH });
    const { appContext } = useContext(AppContext);
    const appConfig = appContext.config.themeConfig;
    const renderCategoryChildrenRef = useCallback((category, depth = 1) => {
        return (
            <li
                key={category.id}
            >
                <SidebarCategory
                    title={category.title}
                    isExpanded={false}
                    url={category.url}
                    depth={depth}
                >
                    {category.children && category.children.length > 0 ? category.children.map((child) => renderCategoryChildrenRef(child, depth + 1)) : null}
                </SidebarCategory>
            </li>
        );
    }, []);

    const fetchCollectionNavigationMenus = useCallback(async () => {
        try {
            setLoadingCollection(true);
            const url = new URL('api/nav', process.env.APP_URL);
            url.searchParams.append('collectionUrlPrefix', collectionPath[0].pathBeforeParams);
            url.searchParams.append('depth', appConfig.sideBarNavigationMenuMaxDepth || DEFAULT_MAXIMUM_NAVIGATION_MENU_DEPTH);
            const response = await fetch(url);
            const data = await response.json();
            setCollectionNavigationMenus(data.navData || []);
            setLoadingCollection(false);
        } catch (e) {
            setError(e.message);
            setLoadingCollection(false);
        }
    }, []);

    useEffect(() => {
        fetchCollectionNavigationMenus();
    }, []);

    if (loadingCollection) {
        return (
            <div
                className={'p-2'}>Loading categories...</div>
        );
    } else if (error) {
        return (
            <div
                className={'p-2'}>Error loading categories: {error}</div>
        );
    }
    return (
        collectionNavigationMenus.map((menu) => (
            <SidebarCategory
                key={menu.id}
                title={menu.title}
                isExpanded={false}
                url={menu.url}
                depth={0}
            >
                {menu.children?.map((child) => renderCategoryChildrenRef(child))}
            </SidebarCategory>
        ))
    );
};

export default PageSidebarCategoryList;